import { forwardRef } from 'react';

import { ExportOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

/**
 * @param {Object} props
 * @param {Object} props.relation - Unified relation item from the API.
 * @param {string} props.relation.relatedTitle - Title of the related article.
 * @param {string} props.relation.relatedType - Encyclopedia type of the related article (e.g. 'dia').
 * @param {number} props.relation.relatedId - ID of the related article.
 */
const RelationItem = forwardRef(function RelationItem({ relation }, ref) {
  const pillItems = [
    relation?.relatedType && { label: 'Ansiklopedi', value: relation.relatedType.toUpperCase() },
    relation?.articleGroup && { label: 'Madde Grubu', value: relation.articleGroup },
    relation?.articleType && { label: 'Madde Türü', value: relation.articleType },
    relation?.committee && { label: 'İlim Heyeti', value: relation.committee },
    relation?.lifespan && { label: 'Doğum/Ölüm', value: relation.lifespan },
    relation?.isAbandoned && { value: 'Terk', color: '#1890ff' },
    relation?.isDraft && { value: 'Taslak', color: '#fa8c16' },
    relation?.isCancelled && { value: 'İptal', color: '#f5222d' },
  ].filter(Boolean);

  const textItems = [
    relation?.lead && { label: 'Takdim', value: relation.lead },
    relation?.kunya && { label: 'Künye', value: relation.kunya },
  ].filter(Boolean);

  return (
    <Link
      ref={ref}
      to={`/madde-iliskilendirme-yonetimi/duzenle/${relation?.relatedType}-${relation?.relatedId}`}
      className="gx-d-flex"
      style={{
        border: '1px solid #e8e8e8',
        borderRadius: 4,
        padding: '8px 12px',
        marginBottom: 8,
        color: 'inherit',
        transition: 'border-color 0.2s',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = '#1890ff';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = '#e8e8e8';
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="gx-d-flex gx-align-items-center" style={{ gap: 6 }}>
          <span style={{ fontWeight: 500 }}>{relation?.relatedTitle}</span>
          {relation?.resourceUrl && (
            <a
              href={relation.resourceUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={(e) => e.stopPropagation()}
            >
              <ExportOutlined style={{ fontSize: 14, color: '#1890ff' }} />
            </a>
          )}
        </div>
        {textItems.map((item, index) => (
          <div key={index} style={{ fontSize: 11, color: '#888', marginTop: 2 }}>
            <strong>{item.label}:</strong> {item.value}
          </div>
        ))}
        {pillItems.length > 0 && (
          <div className="gx-d-flex" style={{ flexWrap: 'wrap', gap: 4, marginTop: 4 }}>
            {pillItems.map((item, index) => (
              <span
                key={index}
                style={{
                  fontSize: 11,
                  padding: '1px 6px',
                  borderRadius: 4,
                  backgroundColor: item.color ? `${item.color}10` : '#f5f5f5',
                  color: item.color ?? '#888',
                  border: `1px solid ${item.color ? `${item.color}30` : '#e8e8e8'}`,
                  lineHeight: '18px',
                }}
              >
                {item.label ? <><strong>{item.label}:</strong> {item.value}</> : item.value}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
});

export default RelationItem;
